import { render, staticRenderFns } from "./HelpDialog.vue?vue&type=template&id=2b476a08&scoped=true"
import script from "./HelpDialog.vue?vue&type=script&lang=js"
export * from "./HelpDialog.vue?vue&type=script&lang=js"
import style0 from "./HelpDialog.vue?vue&type=style&index=0&id=2b476a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b476a08",
  null
  
)

export default component.exports